export const getEntityPagePath = (path: string) =>
  `/:entityId${path.startsWith("/") ? "" : "/"}${path}`;
